import format from "date-fns/format";
import utc0 from "./utc0";

type DateLike = string | number | Date;

export default function formatDateUtc(value: DateLike) {
  return format(utc0(value || new Date()), "dd MMM yyyy");
}

export function formatDate(value: DateLike) {
  return format(
    typeof value === "string" ? new Date(value) : value,
    "dd MMM yyyy"
  );
}
